import { create } from 'zustand';
import type { AuthPayload, CurrentUser, TenantPublicSettings, WorkSessionSummary } from '@stoplord/shared';

export type AuthStatus = 'loading' | 'authenticated' | 'anonymous';

interface AuthState {
  status: AuthStatus;
  /** Kept in memory only — never persisted to localStorage. */
  accessToken: string | null;
  user: CurrentUser | null;
  tenant: TenantPublicSettings | null;
  workSession: WorkSessionSummary | null;
  signOutReason: string | null;
  setSession: (p: AuthPayload) => void;
  setProfile: (p: Omit<AuthPayload, 'accessToken' | 'accessTokenExpiresAt'>) => void;
  setWorkSession: (ws: WorkSessionSummary | null) => void;
  clear: (reason?: string | null) => void;
}

export const useAuth = create<AuthState>((set) => ({
  status: 'loading',
  accessToken: null,
  user: null,
  tenant: null,
  workSession: null,
  signOutReason: null,
  setSession: (p) =>
    set({ status: 'authenticated', accessToken: p.accessToken, user: p.user, tenant: p.tenant, workSession: p.workSession, signOutReason: null }),
  setProfile: (p) => set({ user: p.user, tenant: p.tenant, workSession: p.workSession }),
  setWorkSession: (workSession) => set({ workSession }),
  clear: (reason = null) =>
    set({ status: 'anonymous', accessToken: null, user: null, tenant: null, workSession: null, signOutReason: reason }),
}));

export const authSnapshot = () => useAuth.getState();

/** Stable empty array for selectors (a fresh [] each render would loop useSyncExternalStore). */
export const EMPTY: never[] = [];
